exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contentful-recipe-category-js": () => import("./../../../src/pages/{ContentfulRecipe.category}.js" /* webpackChunkName: "component---src-pages-contentful-recipe-category-js" */),
  "component---src-pages-contentful-recipe-title-js": () => import("./../../../src/pages/{ContentfulRecipe.title}.js" /* webpackChunkName: "component---src-pages-contentful-recipe-title-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

